/* eslint-disable i18n-scan/no-inline-content */
import React, { useState } from 'react'
import { IconChevron } from '../chevron'
import { MobileMenuItem } from './mobile-menu-item'
import PropTypes from 'prop-types'
import { UserIcon } from '../user-icon'
import { LoginButton } from '../login-button'
import { BackArrow } from '../back-arrow'
import { Message } from '@paypalcorp/worldready-react'
import { getUserType } from '../../../utils/user-utils'
import {ACCOUNT_TYPE} from '../../../common/constant'


export const MobileMenu = ({
  currentUser,
  menuContent,
  userMenuContent,
  setLogin,
  onClose,
}) => {
  const [selectedItem, setSelectedItem] = useState('all')
  const accountType = getUserType(currentUser)

  const FULL_NAME =
    accountType === ACCOUNT_TYPE.IDENTITY
      ? currentUser?.email
      : currentUser?.firstName + ' ' + currentUser?.lastName

  const handleSelectedItem = (title) => {
    setSelectedItem(title)
  }

  const renderMenuItems = (() => {
    return menuContent.map((item, index) => {
      if (selectedItem === 'all') {
        return (
          <div className="dev_dash__mobile-menu--link-wrapper" key={index}>
            <MobileMenuItem
              className="dev_dash__mobile-menu--button"
              onClick={() => handleSelectedItem(item.title)}
              path={item?.path}
            >
              <span
                className="dev_dash__mobile-menu--title"
                data-cy={`mobile-menu-title-${item.title
                  .toString()
                  .toLowerCase()
                  .replace(/\s+/g, '-')}`}
              >
                {item.title}
              </span>
              <IconChevron displayDirection="right" />
            </MobileMenuItem>
          </div>
        )
      }

      if (selectedItem === item.title) {
        return (
          <>
            <div className="dev_dash__mobile-menu--goback-container">
              <button
                onClick={() => handleSelectedItem('all')}
                className="dev_dash__mobile-menu--goback-button"
                data-cy={`dev_dash__mobile-menu--goback-button-${item.title
                  .toString()
                  .toLowerCase()
                  .replace(/\s+/g, '-')}`}
              >
                <BackArrow />
              </button>
              <h2 className="dev_dash__mobile-menu--active_title ">
                {item.title}
              </h2>
            </div>
            {item.content.map((child, idx) => (
              <div className="dev_dash__mobile-menu--link-wrapper" key={idx}>
                <MobileMenuItem
                  className="dev_dash__mobile-menu--button"
                  path={child?.path}
                >
                  <span className="dev_dash__mobile-menu--title">
                    {child.title}
                  </span>
                  <IconChevron displayDirection="right" />
                </MobileMenuItem>
              </div>
            ))}
          </>
        )
      }

      return null
    })
  })()

  const renderUserMenu = (() => {
    if (selectedItem !== 'all' && selectedItem === currentUser) {
      return (
        <>
          <div className="dev_dash__mobile-menu--goback-container">
            <button
              onClick={() => handleSelectedItem('all')}
              className="dev_dash__mobile-menu--goback-button"
            >
              <BackArrow />
            </button>
            <h2 className="dev_dash__mobile-menu--active_title ">
              {FULL_NAME}
            </h2>
          </div>
          {userMenuContent.map((item, index) => (
            <div className="dev_dash__mobile-menu--link-wrapper" key={index}>
              <MobileMenuItem
                className="dev_dash__mobile-menu--button"
                path={item.path}
                onClose={onClose}
              >
                <span className="dev_dash__mobile-menu--title">
                  {item.title}
                </span>
                <IconChevron displayDirection="right" />
              </MobileMenuItem>
            </div>
          ))}
        </>
      )
    }

    return (
      <div className="dev_dash__mobile-menu--link-wrapper">
        <MobileMenuItem
          className="dev_dash__mobile-menu--button"
          onClick={() => setSelectedItem(currentUser)}
        >
          <div className="dev_dash__mobile-menu--user-container">
            <span
              className="dev_dash__mobile-menu--title"
              style={{ marginRight: '1rem' }}
            >
              {FULL_NAME}
            </span>
            <UserIcon />
          </div>
          <IconChevron displayDirection="right" />
        </MobileMenuItem>
      </div>
    )
  })()

  return (
    <div className="dev_dash__mobile-menu--wrapper">
      <div className="dev_dash__mobile-menu--container">
        <div className="dev_dash__mobile-menu--sub-container">
          <div className="dev_dash__mobile-menu--items-wrapper">
            <div className="dev_dash__mobile-menu--items-container">
              {currentUser && renderUserMenu}
              {renderMenuItems}
              {selectedItem === 'all' && !currentUser && (
                <div className="dev_dash__mobile-menu--login_button_container">
                  <LoginButton
                    onClick={setLogin}
                    data-dxa="login,nav-click,nav-login"
                  >
                    <Message id="home.loginBtn.title" />
                  </LoginButton>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

MobileMenu.propTypes = {
  currentUser: PropTypes.object,
  setLogin: PropTypes.func,
  onClose: PropTypes.func,
  menuContent: PropTypes.array,
  userMenuContent: PropTypes.array,
}
